module.exports = __webpack_public_path__ + "img/about_banner.9bc379b0.jpg";